import styles from "../styles/ChatbotData.module.css";
import React, { useContext, useState } from "react";
import { IoCloseSharp } from "react-icons/io5";
import { LanguageContext } from "./App";

export default function Embedding({ supabaseData }) {
  const [language, setLanguage] = useContext(LanguageContext);

  const embed =
    language === "en"
      ? `
  <script>
    const supabaseData= "${supabaseData}";

    const lang = 'en'

    fetch("https://cyberchat-html.vercel.app/")
      .then((response) => response.text())
      .then((htmlContent) => {
        const container = document.createElement("div");
        container.innerHTML = htmlContent;

        document.body.appendChild(container);

        const scriptTags = container.getElementsByTagName("script");
        for (let i = 0; i < scriptTags.length; i++) {
          const script = document.createElement("script");
          script.innerHTML = scriptTags[i].innerHTML;
          document.body.appendChild(script);
        }
      })
      .catch((error) =>
        console.error("Error fetching external HTML:", error)
      );
  </script>`
      : `
  <script>
    const supabaseData= "${supabaseData}";

    fetch("https://cyberchat-html.vercel.app/")
      .then((response) => response.text())
      .then((htmlContent) => {
        const container = document.createElement("div");
        container.innerHTML = htmlContent;

        document.body.appendChild(container);

        const scriptTags = container.getElementsByTagName("script");
        for (let i = 0; i < scriptTags.length; i++) {
          const script = document.createElement("script");
          script.innerHTML = scriptTags[i].innerHTML;
          document.body.appendChild(script);
        }
      })
      .catch((error) =>
        console.error("Error fetching external HTML:", error)
      );
  </script>`;

  const [modal, setModal] = useState(false);

  return (
    <div
      style={{
        height: "100vh",
        width: "100wv",
        display: "flex",
        justifyContent: "center",
        // padding: 10,
        // overflow: "hidden",

        borderRadius: 12,
        // width: "50vw",
        right: 0,
        margin: 20,
        padding: 20,

        fontFamily: "Jost",
        fontWeight: 600,
        scrollbarWidth: "none",
        overflow: "scroll",
      }}
    >
      {modal ? (
        <div
          style={{
            padding: "20px",

            boxShadow: " 0 0 10px rgba(0, 0, 0, 0.1)",

            alignItems: "center",
            flexDirection: "column",
            position: "absolute",
            fontFamily: "Jost",
            fontWeight: 600,

            display: "flex",
            justifyContent: "flex-start",
            alignSelf: "center",
            justifySelf: "center",

            backgroundColor: "#000",
            marginBottom: 40,

            width: "80%",
            height: "90%",

            borderRadius: 8,
            zIndex: 10000,
            marginTop: -15,
          }}
        >
          <button
            className={styles["backBtn"]}
            onClick={() => {
              setModal(false);
            }}
            style={{ alignSelf: "flex-start" }}
          >
            <IoCloseSharp size={20} color="#fff" height={5} width={5} />
          </button>
          <h3 style={{ textAlign: "center", color: "#fff" }}>
            {language === "en"
              ? `If your website was created using a website builder, here are guides for the most popular ones 
                      (If yours is not listed here, search online for "Insert HTML + your website builder's name"):`
              : `Если ваш сайт был содан с помощью конструктора сайтов, вот
                    гайды для самых популярных из них (Если вашего здесь нет,
                    поищите в интернете "Вставка HTML + название вашего
                    конструктора"):`}{" "}
          </h3>

          {language === "en" ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                color: "#16a34a",
              }}
            >
              <a
                href="https://help.tilda.cc/html#:~:text=To%20insert%20code%20in%20the,code%20for%20the%20head%20section."
                target="_blank"
                rel="noreferrer"
              >
                Tilda
              </a>
              <a
                href="https://ecomposer.io/blogs/news/shopify-custom-html-section"
                target="_blank"
                rel="noreferrer"
              >
                Shopify
              </a>
              <a
                href="https://wordpress.com/support/wordpress-editor/blocks/custom-html-block/#:~:text=%D0%A7%D1%82%D0%BE%D0%B1%D1%8B%20%D0%B4%D0%BE%D0%B1%D0%B0%D0%B2%D0%B8%D1%82%D1%8C%20%D0%B1%D0%BB%D0%BE%D0%BA%20%C2%AB%D0%9F%D1%80%D0%BE%D0%B8%D0%B7%D0%B2%D0%BE%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9%20HTML,%D0%BD%D0%BE%D0%B2%D0%BE%D0%B9%20%D1%81%D1%82%D1%80%D0%BE%D0%BA%D0%B5%20%D0%B8%20%D0%BD%D0%B0%D0%B6%D0%BC%D0%B8%D1%82%D0%B5%20Enter."
                target="_blank"
                rel="noreferrer"
              >
                Wordpress
              </a>
              <a
                href="https://www.websitebuilderinsider.com/how-do-i-embed-html-code-into-weebly/"
                target="_blank"
                rel="noreferrer"
              >
                Weebly
              </a>
              <a
                href="https://support.wix.com/en/article/wix-editor-embedding-a-site-or-a-widget"
                target="_blank"
                rel="noreferrer"
              >
                Wix
              </a>
              <a
                href="https://support.squarespace.com/hc/en-us/articles/205815928-Adding-custom-code-to-your-site"
                target="_blank"
                rel="noreferrer"
              >
                Squarespace
              </a>
              <a
                href="https://carrd.co/docs/building/embedding-custom-code"
                target="_blank"
                rel="noreferrer"
              >
                Carrd
              </a>
              <a
                href="https://university.webflow.com/lesson/custom-code-embed"
                target="_blank"
                rel="noreferrer"
              >
                Webflow
              </a>
              <a
                href="https://www.godaddy.com/help/add-html-or-custom-code-to-my-site-27252"
                target="_blank"
                rel="noreferrer"
              >
                GoDaddy
              </a>
              <a
                href="https://www.themexpert.com/docs/quix-builder/elements/custom-html-element"
                target="_blank"
                rel="noreferrer"
              >
                Quix
              </a>
              <a
                href="https://www.commoninja.com/widgets/code-snippets/web-com-website-builder/how-to-add"
                target="_blank"
                rel="noreferrer"
              >
                Web.com
              </a>{" "}
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                color: "#16a34a",
              }}
            >
              <a
                href="https://help-ru.tilda.cc/html#:~:text=%D0%9A%D0%B0%D0%BA%20%D0%B4%D0%BE%D0%B1%D0%B0%D0%B2%D0%B8%D1%82%D1%8C%20HTML%2D%D0%BA%D0%BE%D0%B4%20%D0%B2,%D0%BA%D0%BE%D0%B4%20%D0%B4%D0%BB%D1%8F%20%D0%B2%D1%81%D1%82%D0%B0%D0%B2%D0%BA%D0%B8%20%D0%B2%D0%BD%D1%83%D1%82%D1%80%D1%8C%20head%C2%BB."
                target="_blank"
                rel="noreferrer"
              >
                Tilda
              </a>
              <a
                href="https://ecomposer.io/blogs/news/shopify-custom-html-section"
                target="_blank"
                rel="noreferrer"
              >
                Shopify
              </a>
              <a
                href="https://www.insales.ru/collection/doc-chasto-zadavaemye-voprosy/product/kak-dobavit-meta-teg-skript-ili-inoy-kod-na-sayt"
                target="_blank"
                rel="noreferrer"
              >
                InSales
              </a>
              <a
                href="https://wordpress.com/ru/support/wordpress-editor/blocks/custom-html-block/#:~:text=%D0%A7%D1%82%D0%BE%D0%B1%D1%8B%20%D0%B4%D0%BE%D0%B1%D0%B0%D0%B2%D0%B8%D1%82%D1%8C%20%D0%B1%D0%BB%D0%BE%D0%BA%20%C2%AB%D0%9F%D1%80%D0%BE%D0%B8%D0%B7%D0%B2%D0%BE%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9%20HTML,%D0%BD%D0%BE%D0%B2%D0%BE%D0%B9%20%D1%81%D1%82%D1%80%D0%BE%D0%BA%D0%B5%20%D0%B8%20%D0%BD%D0%B0%D0%B6%D0%BC%D0%B8%D1%82%D0%B5%20Enter."
                target="_blank"
                rel="noreferrer"
              >
                Wordpress
              </a>
              <a
                href="https://www.websitebuilderinsider.com/how-do-i-embed-html-code-into-weebly/"
                target="_blank"
                rel="noreferrer"
              >
                Weebly
              </a>
              <a
                href="https://support.wix.com/ru/article/%D1%80%D0%B5%D0%B4%D0%B0%D0%BA%D1%82%D0%BE%D1%80-wix-%D0%B2%D1%81%D1%82%D1%80%D0%B0%D0%B8%D0%B2%D0%B0%D0%BD%D0%B8%D0%B5-%D1%81%D1%82%D0%BE%D1%80%D0%BE%D0%BD%D0%BD%D0%B5%D0%B3%D0%BE-%D1%81%D0%B0%D0%B9%D1%82%D0%B0-%D0%B8%D0%BB%D0%B8-%D0%B2%D0%B8%D0%B4%D0%B6%D0%B5%D1%82%D0%B0"
                target="_blank"
                rel="noreferrer"
              >
                Wix
              </a>
              <a
                href="https://support.squarespace.com/hc/en-us/articles/205815928-Adding-custom-code-to-your-site"
                target="_blank"
                rel="noreferrer"
              >
                Squarespace
              </a>
              <a
                href="https://craftum.com/blog/5-sposobov-sdelat-vash-sajt-funkcionalnee/"
                target="_blank"
                rel="noreferrer"
              >
                Craftum
              </a>
              <a
                href="https://ukit.com/ru/help/kak-dobavit-html-kod"
                target="_blank"
                rel="noreferrer"
              >
                uKit
              </a>
              <a
                href="https://nethouse.ru/about/instructions/kak_dobavit_na_sajt_blok_html"
                target="_blank"
                rel="noreferrer"
              >
                Nethouse
              </a>
              <a
                href="https://tobiz.net/support/kak-dobavit-html-kod-na-svoj-sajt/"
                target="_blank"
                rel="noreferrer"
              >
                Tobiz
              </a>
              <a
                href="https://carrd.co/docs/building/embedding-custom-code"
                target="_blank"
                rel="noreferrer"
              >
                Carrd
              </a>
              <a
                href="https://help.marquiz.ru/article/671"
                target="_blank"
                rel="noreferrer"
              >
                Flexbe
              </a>
              <a
                href="https://help.pixpa.com/ru/kb/embed-any-external-script/"
                target="_blank"
                rel="noreferrer"
                color="#16a34a"
              >
                Pixpa
              </a>
              <a
                href="https://gmodz.ru/kak-dobavit-polzovatelskii-kod-v-webflow-2/"
                target="_blank"
                rel="noreferrer"
              >
                Webflow
              </a>
              <a
                href="https://www.godaddy.com/help/add-html-or-custom-code-to-my-site-27252"
                target="_blank"
                rel="noreferrer"
              >
                GoDaddy
              </a>
              <a
                href="https://www.themexpert.com/docs/quix-builder/elements/custom-html-element"
                target="_blank"
                rel="noreferrer"
              >
                Quix
              </a>
              <a
                href="https://www.commoninja.com/widgets/code-snippets/web-com-website-builder/how-to-add"
                target="_blank"
                rel="noreferrer"
              >
                Web.com
              </a>{" "}
            </div>
          )}

          <h3 style={{ textAlign: "center", color: "#fff" }}>
            {language === "en"
              ? `If your website was coded manually, please ask your developer to insert this block into your site; it shouldn't be difficult for them. Alternatively, you can contact us at`
              : `Если ваш сайт был написан вручную, пожалуйста, попросите
                    разработчика вставить на сайт этот блок, для них это не должно
                    составить труда. Или вы можете написать нам в`}{" "}
            <a
              href="https://t.me/holygoose"
              target="_blank"
              rel="noreferrer"
              style={{ color: " #16a34a" }}
            >
              Telegram
            </a>
            ,{" "}
            <a
              href="https://wa.me/+79826005377"
              target="_blank"
              rel="noreferrer"
              style={{ color: " #16a34a" }}
            >
              WhatsApp
            </a>{" "}
            {language === "en" ? `or` : `или`}{" "}
            <a
              href="https://twitter.com/artemy_medvedev"
              target="_blank"
              rel="noreferrer"
              style={{ color: " #16a34a" }}
            >
              Twitter (X)
            </a>{" "}
            {language === "en"
              ? `and we will be able to assist you. However, we recommend asking your developer, as they have a better understanding of the architecture of your specific website.`
              : `и мы сможем вам помочь. Но мы рекомендуем попросить
                    разработчика, ведь он лучше понимает архитектуру именно вашего
                    сайта.`}{" "}
          </h3>
        </div>
      ) : null}
      <div>
        <h3 style={{ textAlign: "center", color: "#000" }}>
          {language === "en"
            ? `Embed this code on your website`
            : `Вставьте этот код на свой сайт`}
          <br />
          <button
            onClick={() => {
              setModal(true);
            }}
            className={styles["submit-btn"]}
            style={{
              marginBottom: 10,
            }}
          >
            {language === "en"
              ? "How to integrate on a website"
              : "Как интегрировать на сайт"}
          </button>
          <br />
          {language === "en"
            ? "If you have any questions:"
            : "Если у вас есть вопросы:"}{" "}
          <a
            href="https://t.me/holygoose"
            target="_blank"
            rel="noreferrer"
            style={{ color: " #16a34a" }}
          >
            Telegram
          </a>
          ,{" "}
          <a
            href="https://wa.me/+79826005377"
            target="_blank"
            rel="noreferrer"
            style={{ color: " #16a34a" }}
          >
            WhatsApp
          </a>{" "}
          {language === "en" ? `or` : `или`}{" "}
          <a
            href="https://twitter.com/artemy_medvedev"
            target="_blank"
            rel="noreferrer"
            style={{ color: " #16a34a" }}
          >
            Twitter (X)
          </a>
        </h3>
        <textarea
          value={embed}
          className={styles["param-input"]}
          readOnly={true}
          style={{
            width: "70vw",
          }}
        ></textarea>
      </div>
    </div>
  );
}
